import { combineReducers } from 'redux';
import { directionReducer } from './DirectionReducer';
import { outboundPostalOperatorReducer } from './OutboundPostalOperatorReducer';
import { inboundPostalOperatorReducer } from './InboundPostalOperatorReducer';
import { departurePostalOperatorsReducer } from './DeparturePostalOperatorReducer';
import { arrivalPostalOperatorsReducer } from './ArrivalPostalOperatorReducer';

export default combineReducers({
  directions: directionReducer,
  inbound: inboundPostalOperatorReducer,
  outbound: outboundPostalOperatorReducer,
  departure: departurePostalOperatorsReducer,
  arrival: arrivalPostalOperatorsReducer,
});
